<div class="card-content">
  <div class="nav-tabs-navigation">
    <div class="nav-tabs-wrapper">
      <ul id="tabs" class="nav nav-tabs" data-tabs="tabs">          
          <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <a  routerLink="/invoices">Invoice List</a>
          </li>
          <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <a routerLink="/invoices/generator">Invoice Generator</a>
          </li>
      </ul>
    </div>
  </div>
  <div class="tab-content">
    <div class="tab-pane active">
      <router-outlet></router-outlet>
    </div>    
  </div>
</div>

